import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Optional, Output, SimpleChanges } from '@angular/core';

import { FormArray, FormGroup } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';

import { Subscription } from 'rxjs';

import { ConfirmationMessageComponent } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/components/confirmation-message/confirmation-message.component';

import { TipoMensajeConfirmacion } from 'src/app/shared/components/sqp-components/sqpMensajeConfirmacion/models/confirmation-message-data';

import { TipoFirmante } from '../../../envios/models/tipo-firmante';

import { ErroresForm, FirmanteNif, TipoFirma } from '../../models/firmante-nif';

import { DatosConfiguracionDocumentosService } from '../../services/datos-configuracion-documentos.service';

import {
  CODIGO_FIRMANTE_PRINCIPAL,
  MAX_FIRMANTES_ENVIO_SIMPLE,
  construirFirmanteVacio
} from '../../services/firmante-envio-simple-factory';

import { FormularioDocumentoService } from '../../services/formulario-documento.service';

import { MODO_ENVIO_SIMPLE } from '../../services/modo-envio-simple.token';

import { EnvioSimpleFlowService } from 'src/app/pages/configuracion/envio-simple/services/envio-simple-flow.service';

import { AccionFirmantePanel } from './panel-firmante-card/panel-firmante-card.component';

/** Snapshot UI (seleccionado, tipoErrorFirma). Datos de firmas vía firmantesNif / getFirmasGroup. */
type FirmanteNifUi = FirmanteNif & { seleccionado: boolean; tipoErrorFirma?: string };

@Component({

  selector: 'app-configuracion-documento-panel-firmantes-unificado',

  templateUrl: './configuracion-documento-panel-firmantes-unificado.component.html',

  styleUrls: ['./configuracion-documento-panel-firmantes-unificado.component.css'],

})

export class ConfiguracionDocumentoPanelFirmantesUnificadoComponent implements OnInit, OnDestroy {

  mostrarFirmantes: FirmanteNifUi[] = [];

  accionesPorCodigo: Record<string, AccionFirmantePanel> = {};

  mostrarTiposContenido = false;



  @Input() erroresForm: ErroresForm[] = [];

  @Output() firmanteSeleccionado = new EventEmitter<TipoFirmante>();

  /** Modo Envio simple: firmante principal por defecto, "Anadir firmante" y etiquetas propias. */
  readonly modoEnvioSimple: boolean;

  readonly maxFirmantes = MAX_FIRMANTES_ENVIO_SIMPLE;

  readonly codigoFirmantePrincipal = CODIGO_FIRMANTE_PRINCIPAL;



  private abrirFirmantePanelSubscription: Subscription;

  private firmantesListaSubscription: Subscription;

  private validadorSubscription: Subscription;

  private lastFirmantesListaKey = '';



  constructor(

    public formularioDocumentoService: FormularioDocumentoService,

    private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,

    private dialog: MatDialog,

    @Optional() @Inject(MODO_ENVIO_SIMPLE) modoEnvioSimple: boolean,

    @Optional() private envioSimpleFlowService?: EnvioSimpleFlowService

  ) {
    this.modoEnvioSimple = modoEnvioSimple ?? false;
  }



  ngOnInit(): void {

    this.formularioDocumentoService.resetIndexFirmaPanel();

    this.datosConfiguracionDocumentosService.resetAbrirFirmantePanel();

    this.datosConfiguracionDocumentosService.transferirDatosValidador(true);

    if (this.modoEnvioSimple) {

      this.asegurarFirmantePrincipal();

      // Documentos genericos importan firmantes con sus etiquetas originales;
      // en Envio simple se renumeran a "Firmante principal" + "Firmante 2..n"
      // por codigo ascendente, sin huecos (D9 / 5b.2).
      this.renumerarEnvioSimple();

    }

    this.initMostrarFirmantes();

    this.subscribeFirmantesLista();

    this.abrirFirmantePanelSubscription = this.datosConfiguracionDocumentosService.datosAbrirFirmantePanel$.subscribe(

      (codigo) => {

        if (!codigo) {

          return;

        }

        this.mostrarFirmantes.forEach((x) => {

          x.seleccionado = x.tipoFirmante?.codigo === codigo;

        });

        const firmante = this.mostrarFirmantes.find((x) => x.tipoFirmante?.codigo === codigo);

        if (firmante) {

          this.firmanteSeleccionado.emit(firmante.tipoFirmante);

        }

      }

    );

    this.validadorSubscription = this.datosConfiguracionDocumentosService.datosValidador$.subscribe(() => {

      this.limpiarAccionesFormulariosCamposEnValidador();

    });

  }



  ngOnChanges(changes: SimpleChanges): void {

    if (changes.erroresForm?.currentValue?.length > 0) {

      this.seleccionarFirmanteError();

    }

  }



  ngOnDestroy(): void {

    this.abrirFirmantePanelSubscription?.unsubscribe();

    this.firmantesListaSubscription?.unsubscribe();

    this.validadorSubscription?.unsubscribe();

  }



  get firmantesNif() {

    return this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] as FormArray;

  }



  trackByCodigo(_index: number, firmante: FirmanteNif): string {

    return firmante.tipoFirmante?.codigo ?? String(_index);

  }



  get puedeAnadirFirmante(): boolean {

    if (!this.modoEnvioSimple) {

      return false;

    }

    const count = this.envioSimpleFlowService?.rosterFirmantes.length ?? this.firmantesNif.length;

    return count < this.maxFirmantes;

  }



  /** True si el firmante tiene gadgets en el documento activo (accion limpiar local). */

  firmantePuedeLimpiarse(firmante: FirmanteNif): boolean {

    if (!this.modoEnvioSimple || !this.envioSimpleFlowService) {

      return false;

    }

    const codigo = firmante.tipoFirmante?.codigo;

    const activoId = this.envioSimpleFlowService.documentoActivoId;

    if (!codigo || !activoId) {

      return false;

    }

    return this.envioSimpleFlowService.firmanteTieneConfiguracionEnDocumento(codigo, activoId);

  }



  /** Garantiza el firmante principal (codigo 100) en documentos sin configuracion previa (D5).
   * Si solo hay adicionales (p.ej. generico con codigo 101), promueve el de codigo mas bajo
   * en lugar de anadir un principal vacio que apareceria como "Firmante 2" + aspa incorrecta. */
  private asegurarFirmantePrincipal(): void {
    const firmantes = (this.firmantesNif.value ?? []) as FirmanteNif[];
    const existe = firmantes.some(
      (f: FirmanteNif) => f.tipoFirmante?.codigo === CODIGO_FIRMANTE_PRINCIPAL
    );

    if (existe) {
      return;
    }

    if (firmantes.length === 0) {
      this.formularioDocumentoService.addFirmanteNifInFormArray(
        construirFirmanteVacio(CODIGO_FIRMANTE_PRINCIPAL, 'Firmante principal')
      );
      this.renumerarEnvioSimple();
      return;
    }

    if (this.envioSimpleFlowService) {
      this.envioSimpleFlowService.sincronizarRosterDesdeDocumentos();
    } else {
      const origen = [...firmantes]
        .map(f => f.tipoFirmante?.codigo)
        .filter((codigo): codigo is string => !!codigo)
        .sort((a, b) => Number(a) - Number(b))[0];
      if (!origen) {
        return;
      }
      const remapeados = firmantes.map(firmante =>
        firmante.tipoFirmante?.codigo === origen
          ? {
              ...firmante,
              tipoFirmante: {
                ...firmante.tipoFirmante,
                codigo: CODIGO_FIRMANTE_PRINCIPAL,
                desc: 'Firmante principal'
              }
            }
          : firmante
      );
      this.formularioDocumentoService.actualizarFirmantesNifEnFormulario(
        this.formularioDocumentoService.formularioDocumento,
        remapeados
      );
    }

    this.renumerarEnvioSimple();
  }



  /** Anade un firmante adicional (max 10) y lo deja seleccionado. */

  anadirFirmante(): void {

    if (!this.puedeAnadirFirmante) {

      return;

    }

    if (this.modoEnvioSimple && this.envioSimpleFlowService) {

      const codigo = this.envioSimpleFlowService.agregarFirmanteGlobal();

      if (codigo) {

        this.refrescarTrasCambioEstructural(codigo);

        this.formularioDocumentoService.notifyFirmasStateChanged();

        this.datosConfiguracionDocumentosService.solicitarRefreshOverlaysDocumento();

      }

      return;

    }

    const usados = this.firmantesNif.value.map((f: FirmanteNif) => Number(f.tipoFirmante?.codigo));

    let codigo = 101;

    while (usados.includes(codigo)) {

      codigo++;

    }

    this.formularioDocumentoService.addFirmanteNifInFormArray(

      construirFirmanteVacio(String(codigo), 'Firmante')

    );

    this.renumerarEnvioSimple();

    this.refrescarTrasCambioEstructural(String(codigo));

  }



  /** Quita un firmante adicional (el principal nunca se elimina). */

  quitarFirmante(firmante: FirmanteNif): void {

    const codigo = firmante.tipoFirmante?.codigo;

    if (!codigo || codigo === CODIGO_FIRMANTE_PRINCIPAL) {

      return;

    }

    // Confirmacion previa: quitar un firmante elimina tambien toda su
    // configuracion (global en Envio simple, solo documento activo en estandar).
    const etiqueta = firmante.tipoFirmante?.desc ?? 'firmante';

    let mensaje: string;

    if (this.modoEnvioSimple && this.envioSimpleFlowService) {

      mensaje = `¿Deseas eliminar el ${etiqueta} del envío completo? Se quitará de todos los documentos junto con su configuración.`;

      const docsConConfig = this.envioSimpleFlowService.obtenerDocumentosConConfiguracionFirmante(codigo);

      if (docsConConfig.length > 0) {

        const nombres = docsConConfig.map(doc => doc.nombre).join(', ');

        mensaje += ` Tiene configuración en: ${nombres}.`;

      }

    } else {

      mensaje = `¿Deseas eliminar el ${etiqueta} y toda su configuración?`;

    }

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {

      data: {

        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,

        icono: 'icon-delete',

        titulo: '¿Quitar firmante?',

        mensaje,

        textoConfirmacion: 'Quitar firmante',

        iconoConfirmacion: 'icon-delete',

        textoCancelar: 'Cancelar'

      }

    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === 'OK') {

        if (this.modoEnvioSimple && this.envioSimpleFlowService) {

          this.envioSimpleFlowService.eliminarFirmanteGlobal(codigo);

          this.refrescarTrasCambioEstructural();

          this.formularioDocumentoService.notifyFirmasStateChanged();

          this.datosConfiguracionDocumentosService.solicitarRefreshOverlaysDocumento();

        } else {

          this.eliminarFirmantePorCodigo(codigo);

        }

      }

    });

  }



  /** Limpia la configuracion del firmante solo en el documento activo (D4). */

  limpiarFirmanteEnDocumento(firmante: FirmanteNif): void {

    const codigo = firmante.tipoFirmante?.codigo;

    const activoId = this.envioSimpleFlowService?.documentoActivoId;

    if (!codigo || !activoId || !this.envioSimpleFlowService) {

      return;

    }

    if (!this.envioSimpleFlowService.firmanteTieneConfiguracionEnDocumento(codigo, activoId)) {

      return;

    }

    const etiqueta = firmante.tipoFirmante?.desc ?? 'firmante';

    const docNombre = this.envioSimpleFlowService.documentoActivo?.nombre ?? 'documento activo';

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {

      data: {

        tipo: TipoMensajeConfirmacion.ConfirmacionSimple,

        icono: 'icon-delete-empty',

        titulo: '¿Limpiar configuración?',

        mensaje: `¿Deseas limpiar la configuración del ${etiqueta} solo en "${docNombre}"? El firmante se mantendrá en el envío y en los demás documentos.`,

        textoConfirmacion: 'Limpiar',

        iconoConfirmacion: 'icon-delete-empty',

        textoCancelar: 'Cancelar'

      }

    });

    dialogRef.afterClosed().subscribe(result => {

      if (result !== 'OK') {

        return;

      }

      this.envioSimpleFlowService!.limpiarFirmanteEnDocumento(codigo, activoId);

      const borradores = this.envioSimpleFlowService!.getBorradoresFormulario(activoId);

      if (borradores) {

        this.formularioDocumentoService.formulariosBorradorFormArray = borradores;

      }

      this.refrescarTrasCambioEstructural(codigo);

      this.formularioDocumentoService.notifyFirmasStateChanged();

      this.datosConfiguracionDocumentosService.solicitarRefreshOverlaysDocumento();

    });

  }

  /** Elimina un firmante adicional y reorganiza el panel tras confirmacion. */

  private eliminarFirmantePorCodigo(codigo: string): void {

    const restantes = this.firmantesNif.value.filter(

      (f: FirmanteNif) => f.tipoFirmante?.codigo !== codigo

    );

    this.formularioDocumentoService.formularioDocumento.controls['firmantesNif'] =

      this.formularioDocumentoService.setExistingFirmantesNif(restantes);

    this.renumerarEnvioSimple();

    this.formularioDocumentoService.notifyFirmasStateChanged();

    this.datosConfiguracionDocumentosService.solicitarRefreshOverlaysDocumento();

    this.refrescarTrasCambioEstructural();

  }



  /** Reetiqueta firmantes en orden canonico: principal + "Firmante 2..n" sin huecos (D9). */

  private renumerarEnvioSimple(): void {

    if (!this.modoEnvioSimple) {

      return;

    }

    const ordenados = [...this.firmantesNif.controls].sort(

      (a, b) =>

        Number((a as FormGroup).get('tipoFirmante')?.value?.codigo) -

        Number((b as FormGroup).get('tipoFirmante')?.value?.codigo)

    );

    let posicion = 2;

    ordenados.forEach((ctrl) => {

      const tipoCtrl = (ctrl as FormGroup).get('tipoFirmante') as FormGroup;

      const codigo = tipoCtrl.get('codigo')?.value as string;

      const desc = codigo === CODIGO_FIRMANTE_PRINCIPAL ? 'Firmante principal' : `Firmante ${posicion++}`;

      tipoCtrl.get('desc')?.setValue(desc, { emitEvent: false });

    });

  }



  private subscribeFirmantesLista(): void {

    this.firmantesListaSubscription?.unsubscribe();

    this.firmantesListaSubscription = this.firmantesNif.valueChanges.subscribe(() => {

      this.reconcileFirmantesLista();

    });

  }



  private refrescarTrasCambioEstructural(seleccionarCodigo?: string): void {

    this.accionesPorCodigo = {};

    this.cerrarTiposContenido();

    this.initMostrarFirmantes();

    if (seleccionarCodigo) {

      this.mostrarFirmantes.forEach((x) => {

        x.seleccionado = x.tipoFirmante?.codigo === seleccionarCodigo;

      });

      const firmante = this.mostrarFirmantes.find((x) => x.tipoFirmante?.codigo === seleccionarCodigo);

      if (firmante) {

        this.firmanteSeleccionado.emit(firmante.tipoFirmante);

      }

    }

    this.subscribeFirmantesLista();

  }



  /** Lista estable de firmantes del paso 8; no se recrea al colocar firmas/casillas. */

  private initMostrarFirmantes(): void {

    const controles = this.modoEnvioSimple
      ? [...this.firmantesNif.controls].sort(
          (a, b) =>
            Number((a as FormGroup).get('tipoFirmante')?.value?.codigo) -
            Number((b as FormGroup).get('tipoFirmante')?.value?.codigo)
        )
      : this.firmantesNif.controls;

    this.mostrarFirmantes = controles.map((ctrl) =>

      this.createFirmanteUi((ctrl as FormGroup).getRawValue() as FirmanteNif, false)

    );

    this.lastFirmantesListaKey = this.buildFirmantesListaKey();

  }



  private reconcileFirmantesLista(): void {

    const listaKey = this.buildFirmantesListaKey();

    if (listaKey === this.lastFirmantesListaKey) {

      return;

    }

    this.lastFirmantesListaKey = listaKey;

    const prevSeleccionado = this.mostrarFirmantes.find((x) => x.seleccionado)?.tipoFirmante?.codigo;

    const codigosActuales = (
      this.modoEnvioSimple
        ? [...this.firmantesNif.controls].sort(
            (a, b) =>
              Number((a as FormGroup).get('tipoFirmante')?.value?.codigo) -
              Number((b as FormGroup).get('tipoFirmante')?.value?.codigo)
          )
        : this.firmantesNif.controls
    ).map((ctrl) => (ctrl as FormGroup).get('tipoFirmante')?.value?.codigo as string);

    this.mostrarFirmantes = this.mostrarFirmantes.filter((f) =>

      codigosActuales.includes(f.tipoFirmante?.codigo)

    );

    codigosActuales.forEach((codigo) => {

      if (this.mostrarFirmantes.some((f) => f.tipoFirmante?.codigo === codigo)) {

        return;

      }

      const ctrl = this.firmantesNif.controls.find(

        (c) => (c as FormGroup).get('tipoFirmante')?.value?.codigo === codigo

      ) as FormGroup;

      if (ctrl) {

        this.mostrarFirmantes.push(

          this.createFirmanteUi(ctrl.getRawValue() as FirmanteNif, codigo === prevSeleccionado)

        );

      }

    });

    if (prevSeleccionado) {

      this.mostrarFirmantes.forEach((x) => {

        x.seleccionado = x.tipoFirmante?.codigo === prevSeleccionado;

      });

    }

    if (this.modoEnvioSimple) {
      this.mostrarFirmantes = [...this.mostrarFirmantes].sort(
        (a, b) => Number(a.tipoFirmante?.codigo) - Number(b.tipoFirmante?.codigo)
      );
    }

  }



  private buildFirmantesListaKey(): string {

    return this.firmantesNif.controls

      .map((ctrl) => (ctrl as FormGroup).get('tipoFirmante')?.value?.codigo as string)

      .filter(Boolean)

      .join('|');

  }



  private createFirmanteUi(firmante: FirmanteNif, seleccionado: boolean): FirmanteNifUi {

    return {

      ...firmante,

      seleccionado,

      tipoErrorFirma: undefined,

    };

  }



  toggleExpand(firmante: FirmanteNif): void {
    this.cerrarTodasLasTarjetas();

    this.mostrarFirmantes.forEach((x) => {
      if (x.tipoFirmante.desc === firmante.tipoFirmante.desc) {
        x.seleccionado = !x.seleccionado;
      } else {
        x.seleccionado = false;
      }
    });

    const activo = this.mostrarFirmantes.find((x) => x.tipoFirmante.desc === firmante.tipoFirmante.desc);
    if (activo?.seleccionado) {
      this.firmanteSeleccionado.emit(activo.tipoFirmante);
    }
  }



  onFirmanteSeleccionado(firmante: FirmanteNif): void {

    this.firmanteSeleccionado.emit(firmante.tipoFirmante);

  }



  onAccionChange(codigo: string, accion: AccionFirmantePanel): void {
    this.datosConfiguracionDocumentosService.clearFormularioHighlight();
    if (accion === null) {
      delete this.accionesPorCodigo[codigo];
      return;
    }

    this.cerrarTiposContenido();
    Object.keys(this.accionesPorCodigo).forEach((key) => {
      if (key !== codigo) {
        delete this.accionesPorCodigo[key];
      }
    });
    this.accionesPorCodigo[codigo] = accion;
  }



  onTiposContenidoChange(abrir: boolean): void {
    if (!abrir) {
      this.cerrarTiposContenido();
      return;
    }

    this.datosConfiguracionDocumentosService.clearFormularioHighlight();
    this.accionesPorCodigo = {};
    this.mostrarTiposContenido = true;
  }



  cerrarTiposContenido(): void {
    this.mostrarTiposContenido = false;
  }

  private cerrarTodasLasTarjetas(): void {
    this.accionesPorCodigo = {};
    this.cerrarTiposContenido();
    this.datosConfiguracionDocumentosService.clearFormularioHighlight();
  }



  getAccionActiva(codigo: string): AccionFirmantePanel {

    return this.accionesPorCodigo[codigo] ?? null;

  }



  private limpiarAccionesFormulariosCamposEnValidador(): void {

    this.firmantesNif.controls.forEach((ctrl) => {

      const codigo = (ctrl as FormGroup).get('tipoFirmante')?.value?.codigo as string;

      const tipo = (ctrl as FormGroup).get('firmas')?.get('tipoFirma')?.value;

      if (!codigo || tipo !== TipoFirma.Validador) {

        return;

      }

      const accion = this.accionesPorCodigo[codigo];

      if (accion === 'formularios' || accion === 'campos') {
        delete this.accionesPorCodigo[codigo];
      }

    });

  }



  seleccionarFirmanteError(): void {

    if (!this.erroresForm?.length) {

      return;

    }

    this.mostrarFirmantes.forEach((x) => {

      if (x.tipoFirmante.desc === this.erroresForm[0].firmante.desc) {

        x.seleccionado = true;

        x.tipoErrorFirma = this.erroresForm[0].error;

        this.firmanteSeleccionado.emit(x.tipoFirmante);

      } else {

        x.seleccionado = false;

      }

    });

  }

}

